<template>
  <div
    :class="['captions', { easier }]"
    aria-hidden="true"
  >
    <span
      :class="['cue', { old: cue.old }]"
      v-for="cue in cues"
      :key="cue"
      @click.stop.prevent="$emit( 'select_track', cue.track_id )"
      :style="{
        '--r': cue.r ,
        '--x': cue.x ,
      }"
    >
      {{ cue.text }}
    </span>
  </div>
</template>

<script>

export default {
  name:"Captions",
  props:[
    'cues'
  ],
  computed: {
    easier() {
      return this.$store.state.access.options.cleanCaptions.value
    }
  },
  emits: [
    'select_track'
  ],
  watch: {
    cues: {
      handler() {
        this.$el.scroll({
          top: this.$el.scrollHeight,
          behavior: 'smooth'
        })
      },
      deep: true
    }
  }
}
</script>

<style scoped>
.captions {
  box-sizing: border-box;
  position: relative;
  padding: 1em;
  padding-bottom: 4em;
  padding-top: 25em;
  margin: 1em 0;
  z-index:0;
  height: 30em;
  width: 100%;
  /* margin-right: 3em; */
  overflow: scroll;
  /* -ms-overflow-style: none;  IE and Edge */
  /* scrollbar-width: none;  Firefox */
  /* transition: all var(--slow) ease; */

}
/* .captions::-webkit-scrollbar {
  display: none;
} */

.captions .cue {
  line-height: -1em;
  display: inline-block;
  padding-right: 0.3em;
  opacity: 1;
  transform: translateY(0) rotate(0deg);
  color: var(--light2);
  box-shadow: 0px 0px 10px 0px black;
  background: black;
  /* transition: all var(--slow) ease; */
  animation: fadeAway 20s ease-out forwards;
  color:  var(--light2);
  transform-origin: bottom center;
  transition:
    opacity var(--slow) ease,
    color var(--slow) ease
  ;
}


.isMobile .captions {
  /* pointer-events: none; */
  width: 100%;
  margin: 0 0;
  padding-right: 0em;
  padding-left: 0em;
  padding-bottom: 1em;
  padding-top: 25em;
  height: 5em;
}
.isMobile .captions .cue {
  animation: fadeAwayMobile 20s ease-out forwards;
}

#meditation .captions .cue {
  color: var(--light1);
  animation: fadeAwayMeditation 20s ease-out forwards;
}
#meditation .captions .cue.old {
  animation: none;
  opacity: 0.70;
  color: rgb(196, 196, 196);
  transform:
    translateY(-3em)
    rotate(calc(var(--r) * -2deg))
  ;
}
.captions.easier {
  background: black;
  margin-bottom: 0;
}

#meditation .captions.easier .cue,
.captions.easier .cue {
  animation: none;
  box-shadow: none;
  transform: none;
  opacity: 1;
}


@keyframes fadeAway {
  0% {
    opacity: 0;
    transform:
      translateY(1em)
      rotate(calc(var(--r) * 1deg))
    ;
  }
  5% {
    opacity: 1;
    transform:
      translateY(0)
      rotate(0deg)
    ;
  }
  7% {
    opacity: 1;
    transform:
      translateY(0)
      rotate(0deg)
    ;
  }
  100% {
    opacity: 0;
    transform:
      translateY(-3em)
      rotate(calc(var(--r) * -2deg))
    ;
  }
}

@keyframes fadeAwayMobile {
  0% {
    opacity: 0;
    transform:
      translateY(0)
      rotate(calc(var(--r) * 1deg))
    ;
  }
  5% {
    opacity: 1;
    transform:
      translateY(0)
      rotate(0deg)
    ;
  }
  7% {
    opacity: 1;
    transform:
      translateY(0)
      rotate(0deg)
    ;
  }
  100% {
    opacity: 0;
    transform:
      translateY(-3em)
      rotate(calc(var(--r) * -2deg))
    ;
  }
}

@keyframes fadeAwayMeditation {
  0% {
    opacity: 0;
    color: var(--light1);
    transform:
      translateY(0)
      rotate(calc(var(--r) * 1deg))
    ;
  }
  5% {
    opacity: 1;
    color: var(--light1);
    transform:
      translateY(0)
      rotate(0deg)
    ;
  }
  7% {
    opacity: 1;
    color: var(--light1);
    transform:
      translateY(0)
      rotate(0deg)
    ;
  }
  75% {
    opacity: 0.75;
    color: var(--light1);
    transform:
      translateY(-3em)
      rotate(calc(var(--r) * -2deg))
    ;
  }
  100% {
    opacity: 0.95;
    color: rgb(196, 196, 196);
    transform:
      translateY(-3em)
      rotate(calc(var(--r) * -2deg))
    ;
  }
}

</style>
